// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"5":"31e516971d10af71a302","360":"e5094f0ead826d611f3d"}[chunkId] + ".js";
};